import React from "react"
import { Eye, EyeOff } from "lucide-react"

export default function PasswordVisibilityToggleIcon({ isPasswordVisible, className }) {
  return isPasswordVisible ? <Eye className={className} /> : <EyeOff className={className} />
}

